import React, {useState, useEffect} from "react";
import styled from "styled-components"
import { useNavigate } from "react-router-dom";
import useTokenStore from "../../Store/Store";
import Prev from "../../../img/PrevBlack.png"
import DeleteImg from "../../../img/Delete.png"
import NaverImg from "../../../img/naver.png"
import TossImg from "../../../img/toss.png"
import KakaoImg from "../../../img/kakao.png"
import { useParams } from "react-router-dom"; // 라우터를 쓰고 있다면


import axios from "axios";
import { useCookies } from 'react-cookie';

const Styled={
    Wrap:styled.div`
        width:100%;
        height:100%;
        display:flex;
        justify-content:flex-start;
        align-items:center;
        flex-direction:column;
        background-color:#ffffff;
    `,
    HeaderWrap:styled.div`
        width:100%;
        height:56px;
        display:flex;
        justify-content:center;
        align-items:center;
        flex-direction:column;
        position:fixed;
        z-index:3;
        background-color:#ffffff;
    `,
        Header:styled.div`
            width:90%;
            height:56px;
            display:flex;
            justify-content:space-between;
            align-items:center;
            flex-direction:row;
        `,
            PrevBtn:styled.div`
                width:24px;
                height:24px;
                &:hover{
                    cursor:pointer;
                }
            `,
                PrevImg:styled.img`
                    width:100%;
                    height:100%;
                `,
            HeaderText:styled.p`
                font-size:20px;
                font-weight:600;
                color:#000000;
                margin:0px;
                font-family:'PreFont';
            `,
        Nothing:styled.div`
            width:100%;
            height:56px;
        `,

            ContentWrap:styled.div`
                width:88.8%;
                height:87px;
                display:flex;
                justify-content:space-between;
                align-items:flex-start;
                flex-direction:column;
            `,
                ContentTitleBox:styled.div`
                    width:100%;
                    height:21px;
                    display:flex;
                    justify-content:flex-start;
                    align-items:center;
                    flex-direction:row;
                `,
                    ContentTitle:styled.p`
                        font-size:18px;
                        font-weight:600;
                        color:#000000;
                        margin:0px;
                        font-family:'PreFont';
                    `,
                ContentInputWrap:styled.div`
                    width:100%;
                    height:56px;
                    display:flex;
                    justify-content:center;
                    align-items:center;
                    flex-direction:row;
                    border-radius:10px;
                    background-color:#F0F0F0;
                `,
                    ContentInput:styled.input`
                        width:90%;
                        height:90%;
                        &:focus {
                            outline: none;
                            box-shadow: none;
                            border: none;
                        }
                        font-size:14px;
                        font-weight:400;
                        color:#000000;
                        margin:0px;
                        font-family:'PreFont';
                        background-color:#F0F0F0;
                        border:none;
                    `,

        PaymentsWrap:styled.div`
            width:90%;
            height:328px;
            display:flex;
            justify-content:flex-start;
            align-items:center;
            flex-direction:column;
        `,
            PaymentTitleBox:styled.div`
                width:100%;
                height:48px;
                display:flex;
                justify-content:flex-start;
                align-items:center;
                flex-direction:row;
            `,
                PaymentTitle:styled.p`
                    font-size:16px;
                    font-weight:600;
                    color:#000000;
                    margin:0px;
                    font-family:'PreFont';
                `,
            PaymentsChoiceWrap:styled.div`
                width:100%;
                height:260px;
                display:flex;
                justify-content:space-between;
                align-items:center;
                flex-direction:row;
                flex-wrap:wrap;
            `,
                PaymentsChoiceBox:styled.div`
                    width:48.4%;
                    height:80px;
                    border-radius:10px;
                    border:1px solid #D8D8D8;
                    display:flex;
                    justify-content:center;
                    align-items:center;
                    flex-direction:row;
                `,
                    PaymentsImg:styled.img`
                        width:auto;
                        height:auto;
                    `,
                    PaymentsText:styled.p`
                        font-size:14px;
                        font-weight:400;
                        color:#767676;
                        margin:0px;
                        font-family:'PreFont';
                    `,



                FooterNothing:styled.div`
                    width:100%;
                    height:140px;
                `,
        Footer:styled.div`
            width:100%;
            height:100px;
            display:flex;
            justify-content:center;
            align-items:flex-start;
            flex-direction:row;
            background-color:#ffffff;
            z-index:3;
            position:fixed;
            bottom:0;
            box-shadow: 0px 0px 20px #eeeeee;
        `,
            CallBtn:styled.div`
                width:90%;
                height:50px;
                border-radius:10px;
                background-color:#2277F6;
                display:flex;
                justify-content:center;
                align-items:center;
                flex-direction:row;
                margin-top:10px;
            `,
                BtnText:styled.p`
                    font-size:16px;
                    font-weight:400;
                    color:#ffffff;
                    margin:0px;
                    font-family:'PreFont';
                `,


            EmptyContents:styled.div`
                width:100%;
                height: calc(100vh - 156px);
                display:flex;
                justify-content:center;
                align-items:center;
                flex-direction:column;
            `,
                EmptyText:styled.p`
                    font-size:16px;
                    font-weight:600;
                    color:#919191;
                    margin:0px;
                    font-family:'PreFont';
                `,

}
const CallDetail=()=>{
    const [Langcookies, setLangCookie, removeLangCookie] = useCookies(["PageLang"]);
    const [IDcookies, setIDcookies, removeIDcookies] = useCookies(["restaurant_id"]);
    const [PayChoice, setPayChoice] = useState(true)
    const { uuid } = useParams();
    const [Restaurant_PK, setRestaurant_PK] = useState(undefined)
    const [Table_PK, setTable_PK] = useState(undefined)
    // 카드사를 선택하면 true로 바뀌는 구조였는데
    // 우리가 카드사를 선택할 수 없음. KG이니시스로 가서 카드사를 선택하는 구조라 true로 고정
    // 차후에 PG사를 창업하거나, VAN 서비스까지 가능하면 활성화될듯.
    const CallBtn=styled.div`
        width:90%;
        height:50px;
        border-radius:10px;
        background-color:${PayChoice === false ? "#999999":"#2277F6"};
        display:flex;
        justify-content:center;
        align-items:center;
        flex-direction:row;
        margin-top:10px;
    `;


    const navigate = useNavigate();
    const {
        Pocket,
        setPocket,
    } = useTokenStore()



    const [Title, setTitle] = useState({
        "KR":"요청사항",
        "EN":"Request",
        "CN":"要求事项",
        "JP":"要請事項",
        "FR":"requête",
        "SP":"requerimiento",
        "GR":"Ihre Anfrage",
        "RU":"Требования"
    })
    const [OrderRequest, setOrderRequest] = useState({
        "KR":"추가메뉴",
        "EN":"Additional Menu",
        "CN":"附加菜单",
        "JP":"追加メニュー",
        "FR":"Menu supplémentaire",
        "SP":"Menú adicional",
        "GR":"Zusatzmenü",
        "RU":"Дополнительное меню"
    })
    const [RequestTitle, setRequestTitle] = useState({
        "KR":"요청사항",
        "EN":"Request",
        "CN":"要求事项",
        "JP":"要請事項",
        "FR":"requête",
        "SP":"requerimiento",
        "GR":"Ihre Anfrage",
        "RU":"Требования"
    })
    const [Request, setRequest] = useState({
        "KR":"필요하신 요청사항을 입력해주세요",
        "EN":"Please enter your request",
        "CN":"请输入要求事项",
        "JP":"リクエストを入力してください",
        "FR":"Veuillez entrer votre demande",
        "SP":"Por favor, ingrese su solicitud",
        "GR":"Bitte geben Sie Ihre Wünsche ein!",
        "RU":"Введите запрос!"
    })

    const [Pay, setPay] = useState({
        "KR":"요청하기",
        "EN":"Request",
        "CN":"要求",
        "JP":"要請",
        "FR":"Request",
        "SP":"Request",
        "GR":"Request",
        "RU":"Request"
    })
    const [OptionChangeText, setOptionChangeText] = useState({
        "KR":"옵션변경",
        "EN":"change options",
        "CN":"选项变更",
        "JP":"オプション変更",
        "FR":"changement",
        "SP":"cambio",
        "GR":"Änderung",
        "RU":"изменение"
    }) 


    useEffect(() => {
        if (IDcookies["restaurant_id"]) {
            const first = IDcookies["restaurant_id"].substring(0, 36);     // 앞 절반
            const second = IDcookies["restaurant_id"].substring(36);       // 뒤 절반
        
            setRestaurant_PK(first);
            setTable_PK(second);
            console.log(IDcookies["restaurant_id"])
        } else {
            console.log("ID 값이 없습니다.");
        }
    }, [IDcookies["restaurant_id"]]);

    const axiosInstance = axios.create({
        baseURL: 'https://zzikgomainapi.co.kr/',
    });

    const [inputValue, setInputValue] = useState("");

    const CallDetailApi = async () => {
        try {
            const response = await axiosInstance.post("orders/customer-request/", {
                "table":Table_PK,
                "restaurant":Restaurant_PK,
                "request_contents":inputValue,
                "comment":inputValue
            });
            console.log(response.data)
            navigate(`/${IDcookies["restaurant_id"]}`)
        } catch (error) {
            console.error(error); // 요청에 실패한 경우 에러 메시지 출력
        }
    }
    
    return(
        <Styled.Wrap>
            <Styled.HeaderWrap>
                <Styled.Header>
                    <Styled.PrevBtn 
                        onClick={() => navigate(`/${IDcookies["restaurant_id"]}`)}
                    >
                        <Styled.PrevImg src={Prev}/>
                    </Styled.PrevBtn>
                    <Styled.HeaderText>{Title[Langcookies["PageLang"]]}</Styled.HeaderText>
                    <Styled.PrevBtn />
                </Styled.Header>
            </Styled.HeaderWrap>
            <Styled.Nothing />
            <Styled.ContentWrap>
                <Styled.ContentTitleBox>
                    <Styled.ContentTitle>{Request[Langcookies["PageLang"]]}</Styled.ContentTitle>
                </Styled.ContentTitleBox>
                <Styled.ContentInputWrap>
                    <Styled.ContentInput 
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        placeholder="예) 맵지 않게 해주세요"
                    />
                </Styled.ContentInputWrap>
            </Styled.ContentWrap>
            <Styled.Footer>
                <CallBtn onClick={()=>{
                    // 
                    CallDetailApi()
                }}>
                    <Styled.BtnText>{Pay[Langcookies["PageLang"]]}</Styled.BtnText>
                </CallBtn>
            </Styled.Footer>
        </Styled.Wrap>
    )
    
}
export default CallDetail